import { createSlice } from "@reduxjs/toolkit";
import { prepareNoteWithRepeatedQuestions, searchForNodeInTreeAndReplace } from "utils/helpers";

const initialState = {};

export const slice = createSlice({
	name: "note",
	initialState,
	reducers: {
		update: (state, { payload }) => ({ ...(prepareNoteWithRepeatedQuestions(state, payload) || {}) }),
		replace: (state, { payload }) => ({ ...(prepareNoteWithRepeatedQuestions(state, payload) || {}) }),
		replaceDrugQuestion: ({ medicines = [], ...state }, { payload: { question, medicine } }) => ({
			...(state || {}),
			medicines: medicines?.map(({ questions, ...singleMedicine }) => ({
				...(singleMedicine || {}),
				questions: [
					...(singleMedicine?.medicine?.id === medicine?.id ||
					singleMedicine?.medicine?.value === medicine?.value ||
					singleMedicine?.medicine === medicine
						? [...(searchForNodeInTreeAndReplace({ list: [...(questions || [])], single: question }) || [])]
						: [...(questions || [])]),
				],
			})),
		}),
		replacePatient: (state, { payload: { patient } }) => ({ ...(state || {}), patient_plain_text: patient }),
		delete: () => initialState,
	},
});

export const noteSelector = (state) => state?.note || {};

export const { actions, reducer } = slice;

export default reducer;
